import React from 'react';
import classnames from 'classnames';
import _get from 'lodash/get';
import axios from 'cccisd-axios';
import { Link, withRouter } from 'cccisd-react-router';
import IconCheckmark from 'cccisd-icons/svg/checkmark';
import IconLeft from 'cccisd-icons/arrow-left6';
import IconUser from 'cccisd-icons/user';
import styles from './styles.css';
import logoImg from './logo.svg';

const AppDefs = window.cccisd.appDefs;
const Boilerplate = window.cccisd.boilerplate;
const Fortress = window.cccisd.fortress;

const NavBar = props => {
    const className = 'container'; // WUSTL Folks always want container
    const currPath = props.location.pathname;

    let navItems = [];
    const linksFromAppdefs = _get(
        AppDefs.navs.find(n => n.handle === 'mainNav'),
        'nav',
        []
    );
    const routesFromAppdefs = _get(AppDefs, 'routes', []);
    linksFromAppdefs.forEach(defItem => {
        let constructedItem = {
            handle: defItem.handle,
            render: defItem.render,
        };

        constructedItem.render.params.activeRegex = new RegExp(constructedItem.render.params.activeRegex);
        const matchingRoute = routesFromAppdefs.find(r => r.handle === defItem.handle);
        if (matchingRoute) {
            constructedItem.url = matchingRoute.url;
            navItems.push(constructedItem);
        }
    });

    const loginLink = !Fortress.auth() && (
        <li className={'nav-item ' + (/^\/login/i.test(currPath) ? 'active' : '')}>
            <Link to="/login">LOG IN</Link>
        </li>
    );

    const adminDropdown = Fortress.isSuperUser() && (
        <li className="nav-item dropdown">
            <a
                className="nav-link dropdown-toggle"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
            >
                ADMIN
            </a>
            <ul className="dropdown-menu dropdown-menu-end">
                <li>
                    <Link className="dropdown-item" to="/appdefs/about">
                        ABOUT
                    </Link>
                </li>
                <li>
                    <Link className="dropdown-item" to="/appdefs/logs">
                        LOGS
                    </Link>
                </li>
                <li>
                    <hr className="dropdown-divider" />
                </li>
                <li>
                    <Link className="dropdown-item" to="/quest">
                        QUESTS
                    </Link>
                </li>
                <li>
                    <Link className="dropdown-item" to="/resources/admin">
                        RESOURCES
                    </Link>
                </li>
                <li>
                    <Link className="dropdown-item" to="/shorturls">
                        SHORT URLs
                    </Link>
                </li>
                <li>
                    <hr className="dropdown-divider" />
                </li>
                <li>
                    <Link className="dropdown-item" to="/appdefs/admin/json-editor">
                        APP SETTINGS
                    </Link>
                </li>
            </ul>
        </li>
    );

    const roles = Array.isArray(Fortress?.user?.pawns)
        ? Fortress.user.pawns.filter(r => !['Guest', 'Respondent'].includes(r.name))
        : [];
    const userDropdown = Fortress.auth() && (
        <li className="nav-item dropdown">
            <a
                className="nav-link dropdown-toggle"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
            >
                <IconUser />
            </a>
            <ul className="dropdown-menu dropdown-menu-end">
                <p className={`px-3 ${styles.currUsername}`}>
                    <small>
                        Logged in as <b>{Fortress.user.acting.user.username}</b>
                    </small>
                </p>
                {Fortress.user.acting.id !== Fortress.user.actual.id && (
                    <li>
                        <a
                            className="dropdown-item"
                            href="#"
                            onClick={async e => {
                                e.preventDefault();
                                await axios.get(Boilerplate.route('api.nexus.user.logoutAs'));
                                window.location.href = Boilerplate.url(Fortress.settings.config.after_login_url);
                            }}
                        >
                            <IconLeft spaceRight />
                            RETURN TO {Fortress.user.actual.user.username}
                        </a>
                    </li>
                )}
                {Fortress.user.acting.id === Fortress.user.actual.id &&
                    roles.length > 1 &&
                    roles.map(pawn => (
                        <li>
                            <Link
                                key={pawn.id}
                                to="/"
                                className="dropdown-item"
                                onClick={async e => {
                                    e && e.preventDefault();

                                    if (pawn.id === Fortress.user.pawnId) {
                                        return;
                                    }

                                    const response = await axios.post(Boilerplate.route('api.nexus.user.changeTo'), {
                                        pawn: pawn.id,
                                    });

                                    const redirectUrl = response.data.data.hasIncompleteSiteRegistration
                                        ? Boilerplate.url('/account/registrationSurvey')
                                        : Boilerplate.url(Fortress.settings.config.after_login_url);

                                    window.location.href = redirectUrl;
                                }}
                            >
                                {pawn.id === Fortress.user.pawnId ? (
                                    <IconCheckmark />
                                ) : (
                                    <svg viewBox="0 0 1024 1024">
                                        <g />
                                    </svg>
                                )}
                                {pawn.name}
                            </Link>
                        </li>
                    ))}
                <li>
                    <hr className="dropdown-divider" />
                </li>
                {Fortress.user.acting.id === Fortress.user.actual.id && Fortress.user.user.auth_type !== 'ldap' && (
                    <>
                        <li>
                            <Link to="/account/profile" className="dropdown-item">
                                Update profile
                            </Link>
                        </li>
                        <li>
                            <Link to="/account/updatePassword" className="dropdown-item">
                                Change password
                            </Link>
                        </li>
                        <li>
                            <hr className="dropdown-divider" />
                        </li>
                    </>
                )}
                <li>
                    <hr className="dropdown-divider" />
                </li>
                <li>
                    <a className="dropdown-item" href={Boilerplate.url('api/user/logout')}>
                        LOG OUT
                    </a>
                </li>
            </ul>
        </li>
    );

    return (
        <div className={styles.headerWrapper}>
            <div className={styles.branding}>
                <div className={className} style={{ padding: 0 }}>
                    <img
                        alt="Washington University School of Medicine in St. Louis"
                        className={styles.logo}
                        src={logoImg}
                    />
                </div>
            </div>

            <div className={classnames(className, styles.siteName)}>
                <Link to="/">CBT for Eating Disorders</Link>
            </div>

            <nav
                className={`navbar navbar-expand-${Fortress.user.acting.role.handle === 'uberadmin' ? 'xl' : 'lg'} ${
                    styles.links
                }`}
                data-bs-theme="dark"
            >
                <div className={className}>
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon" />
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                            {loginLink}
                            {navItems.map(linkDef => {
                                const isActive = new RegExp(linkDef.render.params.activeRegex).test(currPath);
                                const activeClass = isActive ? 'active' : '';
                                let linkComponent = linkDef.url.startsWith('https') ? (
                                    <a className={'nav-link ' + activeClass} aria-current="page" href={linkDef.url}>
                                        {linkDef.render.params.label}
                                    </a>
                                ) : (
                                    <Link className={'nav-link ' + activeClass} aria-current="page" to={linkDef.url}>
                                        {linkDef.render.params.label}
                                    </Link>
                                );

                                return (
                                    <li className={'nav-item ' + activeClass} key={linkDef.handle}>
                                        {linkComponent}
                                    </li>
                                );
                            })}
                        </ul>
                        <ul className="navbar-nav mb-2 mb-lg-0">
                            {adminDropdown}
                            {userDropdown}
                        </ul>
                    </div>
                </div>
            </nav>
        </div>
    );
};

export default withRouter(NavBar);
